<template>
  <div class="hotelDetail">
    <loading v-if="isShowLoading"></loading>
    <div class="hotel_wrap"> 
       <div class=" width-1200">
        <Breadcrumb separator="＞">
          <BreadcrumbItem :to="{name: 'speciality'}">特产专区</BreadcrumbItem>
          <BreadcrumbItem >特产详情</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div class="titInfo">
        <div class="titleft">
          <div class="top">
            <div class="top_left"><img :src="specialtyObj.mainPic" alt=""></div>
            <div class="top_right">
              <h5>{{specialtyObj.specialtyName}}</h5>
              <p>{{specialtyObj.introduce}}</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="bottom">
            <p class="info">推荐门店：<a>{{specialtyObj.storeName}}</a></p>
            <p class="info">门店电话：{{specialtyObj.storePhone}}</p>
            <p class="info" v-if="specialtyObj.province&&specialtyObj.city">门店地址：{{JSON.parse(specialtyObj.province).label}}省{{JSON.parse(specialtyObj.city).label}}市{{specialtyObj.address}}</p>
          </div>
        </div>
        <div class="titright">
          
           <el-amap vid="amap" :plugin="plugin" class="amap-demo" :center="center"></el-amap>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="content">
        <h4 class="title">{{specialtyObj.specialtyName}}</h4>
        <div v-html="specialtyObj.detail"></div>
      </div>
  
    </div>

  </div>
</template>

<script>
export default {
  // data: function () {
  //   return {
  //     isShowLoading: false,
  //     plugin: [{
  //       pName: 'ToolBar',
  //       events: {
  //         init (instance) {
  //           console.log(instance);
  //         }
  //       }
  //     }]
  //   }
  // },
  data () {
    let self = this;
    return {
      isShowLoading: false,
      specialtyObj: {},
      center: [121.59996, 31.197646],
      lng: 0,
      lat: 0,
      loaded: false,
      plugin: [{
        pName: 'Geolocation',
        events: {
          init (o) {
            // o 是高德地图定位插件实例
            o.getCurrentPosition((status, result) => {
              if (result && result.position) {
                self.lng = result.position.lng;
                self.lat = result.position.lat;
                self.center = [self.lng, self.lat];
                self.loaded = true;
                self.$nextTick();
              }
            });
          }
        }
      }]
    };
  },
  mounted () {
    this.getspecialtyDetail()
  },
  methods: {
    getspecialtyDetail () {
      //http://192.168.90.186:8084/sys/specialty/v1/shop/27
      this.isShowLoading = true;
      let id = this.$route.params.Id;
      let queryUrl = `${this.baseURL}/sys/specialty/v1/shop/${id}`
      queryUrl += '?' + this.QS.stringify({
        // access_token: this.token,
      })
      this.$http.get(queryUrl).then(res => {
        let Data = res.data;
        if (Data.code === 200) {
          this.isShowLoading = false;
          this.specialtyObj = Data.data;
          console.log(this.specialtyObj)

        }
      })
    },
    /*** 景区门票翻页函数**/
    async changePage (num) {

      this.page.page = num;
      window.scrollTo(0, 0);
    },


  }
}
</script>
<style lang="less" scoped>
.hotelDetail {
  .bigtit {
    margin-top: 40px;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
    letter-spacing: 0;
    padding-bottom: 10px;
    border-bottom: 1px dashed #d9dbde;
    span {
      display: inline-block;
      width: 4px;
      background: #2e70ff;
      height: 25px;
      vertical-align: middle;
      margin-right: 8px;
    }
  }
  background-color: #fff;

  .hotel_wrap {
    width: 1200px;
    margin: 0 auto;
    .titInfo {
      .titleft {
        float: left;
        width: 897px;
        .top {
          height: 144px;
          .top_left {
            float: left;
            width: 224px;
            height: 144px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .top_right {
            float: left;
            width: 610px;
            margin-left: 14px;
            h5 {
              font-size: 24px;
              color: #323233;
            }
            p {
              font-size: 14px;
              color: #646566;
            }
          }
        }
        .bottom {
          margin-top: 18px;
          .info {
            font-size: 14px;
            color: #323233;
            line-height: 25px;
          }
        }
      }
      .titright {
        float: right;
        width: 293px;
        height: 189px;
        text-align: center;
        border: 1px solid #eee;
      }
    }
    .content {
      h4 {
        line-height: 35px;
        font-weight: 500;
        font-size: 21px;
        color: #323233;
        text-align: center;
        border-bottom: 1px dashed #d9dbde;
      }
    }

    .clearfix {
      display: block;
      content: " ";
      overflow: hidden;
      clear: both;
    }
  }
}
</style>

<style lang="less">
</style>
